import { Component, inject, OnInit } from '@angular/core';
import { UploadProgressService } from "../../../../../../../core/services/upload-progress.service";
import { TelegramAccountImagesService } from "../../../../services/telegram-account-images.service";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { TelegramAccount } from "../../../../types/telegram-page.types";
import { defaultAccount } from "../../../../configs/telegram-accounts-config";
import { TelegramUploadStatusComponent } from "../telegram-upload-status/telegram-upload-status.component";

@Component({
  selector: 'app-telegram-chat-upload-file',
  standalone: true,
  imports: [
    TelegramUploadStatusComponent
  ],
  templateUrl: './telegram-chat-upload-file.component.html',
  styleUrls: [
    './telegram-chat-upload-file.component.scss',
    '../../telegram-chat-window.component.scss'
  ]
})
export class TelegramChatUploadFileComponent implements OnInit {
  public uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private telegramAccountImagesService: TelegramAccountImagesService = inject(TelegramAccountImagesService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public selectedAccount: TelegramAccount = defaultAccount;

  public ngOnInit(): void {
    this.selectedAccount = this.telegramAccountsService.selectedAccount();
  }

  public getImage(): string {
    return this.telegramAccountImagesService.getAccountImage(this.selectedAccount.accountId);
  }
}
